import React, { Component } from 'react'
import { Box, CircularProgress, Typography } from '@material-ui/core';
import ResourceProfileTable from './ResourceProfileTable';
import Service from '../../config/networkutils';
import Auth from '../../utils/authenticate';


const token = Auth.token()

class ResourceProfileDivision extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: props.tableData || [],
            rolesData: []
        };
        this.handleQuantityUpdated = this.handleQuantityUpdated.bind(this);
    }

    handleQuantityUpdated(rowId, roleId, quantity) {
        const parsedQuantity = Number.parseFloat(quantity);
        const updatedQuantity = Number.isFinite(parsedQuantity) ? parsedQuantity : quantity;

        this.setState(prevState => ({
            data: prevState.data.map(row => {
                if (String(row.id) !== String(rowId)) return row;

                const existingQuantities = Array.isArray(row.qty) ? row.qty : [];
                const hasRoleQuantity = existingQuantities.some(item => String(item.role_id) === String(roleId));
                const qty = hasRoleQuantity
                    ? existingQuantities.map(item => String(item.role_id) === String(roleId)
                        ? { ...item, quantity: updatedQuantity }
                        : item)
                    : [...existingQuantities, { role_id: roleId, quantity: updatedQuantity }];

                return { ...row, qty };
            }),
        }));
    }

    handleRowUpdated(projectTypeId, updates) {
        this.setState(prevState => ({
            data: prevState.data.map(row => String(row.project_type_id) === String(projectTypeId)
                ? { ...row, ...updates }
                : row),
        }));
    }

    handleRowDeleted(projectTypeId) {
        this.setState(prevState => ({
            data: prevState.data.filter(row => String(row.project_type_id ?? row.id) !== String(projectTypeId)),
        }));
    }

    getRoles() {
        Service.get(`/api/roles/get_business_unit_roles/`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({ rolesData: res.data });
            }).catch(error => {
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    componentDidMount() {
        this.getRoles();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.tableData !== this.props.tableData) {
            this.setState({
                data: Array.isArray(this.props.tableData)
                    ? this.props.tableData
                    : this.props.tableData
                        ? [this.props.tableData]
                        : [],
            });
        }
    }

    render() {
        return (
            <div>
                {this.props.isTableLoading ? <Box display='flex' justifyContent={'center'} alignItems='center' width='100%' marginTop={'10px'}><CircularProgress /></Box> :
                    !this.props.selectedDivision || !this.state.data.length ? (
                        <Box
                            display='flex'
                            justifyContent='center'
                            alignItems='center'
                            textAlign='center'
                            minHeight={160}
                            marginTop='10px'
                            padding={2}
                        >
                            <Typography color='primary' style={{ fontWeight: 700, fontSize: 18 }}>
                                {this.props.selectedDivision
                                    ? 'No resource profile data to display for this division.'
                                    : 'Select a division to view resource profile data.'}
                            </Typography>
                        </Box>
                    ) : (
                        <Box marginTop={'10px'}>
                            <ResourceProfileTable
                                disciplineData={this.props.disciplineData}
                                selectedStage={this.props.selectedStage}
                                selectedDivision={this.props.selectedDivision}
                                data={this.state.data}
                                rolesData={this.state.rolesData}
                                workTypeData={this.props.workTypeData}
                                onRefresh={this.props.refreshTable}
                                onQuantityUpdated={this.handleQuantityUpdated}
                                onRowUpdated={this.handleRowUpdated.bind(this)}
                                onRowDeleted={this.handleRowDeleted.bind(this)}
                            />
                        </Box>
                    )
                }
            </div>
        )
    }
}
export default ResourceProfileDivision;
